"use strict";

angular.module("open-iti")
	.controller("OpenFormUserEditCtrl", [
		"$scope", "toastr", "$location", "OpenFormUserService", "$uibModal", "Utils", "subscriberUser",
		function ($scope, toastr, $location, OpenFormUserService, $uibModal, Utils, subscriberUser) {

		$scope.data = {
			subscriberUser: subscriberUser.data
		};

	}]);

